// src/utils/locales.js
// Pendant frontend de backend/utils/locales.js — source unique de normalisation
// des codes langue côté front. Voir docs/PLAN_I18N_MULTILANGUE.md.

export const PLATFORM_LOCALES = ['fr', 'en', 'es']
export const DEFAULT_LOCALE = 'fr'

// 'en-US' → 'en', 'es_CO' → 'es', 'de'/''/null → 'fr'. Toujours une locale valide.
export function normalizeLocale(input) {
  const lang = String(input || '')
    .toLowerCase()
    .split(/[-_]/)[0]
    .trim()
  return PLATFORM_LOCALES.includes(lang) ? lang : DEFAULT_LOCALE
}

// Normalise une liste (tableau OU CSV) de langues supportées par le tenant,
// dédupliquée, en garantissant la présence du fallback 'fr'.
export function parseSupported(arrOrCsv) {
  const list = Array.isArray(arrOrCsv)
    ? arrOrCsv
    : String(arrOrCsv || DEFAULT_LOCALE).split(',')
  const norm = list.map(normalizeLocale)
  const unique = [...new Set(norm)]
  if (!unique.includes(DEFAULT_LOCALE)) unique.unshift(DEFAULT_LOCALE)
  return unique
}
